import { lang } from "../../utilities/lang";
import _ from "lodash";
import { extractCost, handleCartContent, plausibleEvent } from "../../helpers/helpers";
import { Delete } from "../../assets/Delete";
import { Domain, useCart } from "../../context/CartContext";
import { Hosting } from "../../assets/Hosting";
import { useListHosting } from "../../api/useHosting";
import { AddCircle } from "../../assets/AddCircle";
import { useTaxContext } from "../../context/TaxContext";

type CartItemProps = {
    domain: Domain;
};

export const CartItem = ({ domain }: CartItemProps) => {
    const [removeDomain, addHosting, removeHosting, addAuthCode] = useCart((state) => [
        state.removeDomain,
        state.addHosting,
        state.removeHosting,
        state.addAuthCode,
    ]);
    const tax = useTaxContext((state) => state.tax);

    const hostingQuery = useListHosting();
    const hostingData = hostingQuery.isSuccess ? hostingQuery.data.data : [];

    const hostingCost = hostingData.map((d) => d.price_discounted ?? d.price);

    const selectedHosting = domain.hosting ? hostingData.find((h) => h.id.toString() === domain.hosting) : undefined;

    return (
        <li className={`cart-item`}>
            <div className={"domain card"}>
                <div className={`item-content ${domain.status === "taken" ? "transfer" : "buy"}`}>
                    <div className={"domain-name"}>{domain.name}</div>
                    <div className={"buy"}>
                        <span>{extractCost(domain.price, tax.tax_rate)}</span>
                    </div>
                    <div className={"renew"}>
                        <span>
                            {lang.get("Abo-Preis")} {extractCost(domain.renewal, tax.tax_rate)}
                        </span>
                        /<span>{lang.get(_.capitalize(domain.duration))}</span>
                    </div>
                    {domain.status === "taken" ? (
                        <>
                            <div className={"auth-code"}>
                                <input
                                    className={"auth-code__input"}
                                    type={"text"}
                                    placeholder={lang.get("Authcode eingeben")}
                                    value={domain.authCode ?? ""}
                                    onChange={(e) => {
                                        if (e.currentTarget.value) {
                                            addAuthCode(domain, e.currentTarget.value);
                                        } else {
                                            addAuthCode(domain, undefined);
                                        }
                                    }}
                                />
                                <a
                                    href={"https://auth2.de/"}
                                    target={"_blank"}
                                    className={"button red auth-code__request"}
                                    onClick={async () => {
                                        plausibleEvent("auth2-request", domain.name);
                                    }}
                                >
                                    {lang.get("Authcode anfordern")}
                                </a>
                            </div>
                        </>
                    ) : null}
                    {hostingData.length > 0 ? (
                        <div className={"hosting card"}>
                            <div className={"hosting-content"}>
                                <Hosting />
                                {domain.hosting ? (
                                    <>
                                        <div className={"text"}>{selectedHosting?.name}</div>
                                        <select
                                            className={"text"}
                                            value={domain.hosting}
                                            onChange={(e) => {
                                                plausibleEvent("select-hosting", e.currentTarget.value);
                                                addHosting(domain, e.currentTarget.value);
                                            }}
                                        >
                                            {hostingData.map((h) => {
                                                return (
                                                    <option
                                                        className={"hosting-option"}
                                                        key={h.id}
                                                        value={h.id.toString()}
                                                    >
                                                        {h.name} {extractCost((h.price_discounted ?? h.price) / 100, tax.tax_rate)}/
                                                        {lang.get("Jahr")}
                                                    </option>
                                                );
                                            })}
                                        </select>
                                        <div className={"hosting-cost"}>
                                            {extractCost(
                                                (selectedHosting?.setup_price_discounted ??
                                                    selectedHosting?.setup_price) / 100, tax.tax_rate
                                            )}{" "}
                                            Setup
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div className={"text"}>{lang.get("Webhosting hinzufügen")}</div>
                                        <div className={"hosting-cost"}>
                                            {lang.get("ab")} {extractCost(Math.min(...hostingCost) / 100, tax.tax_rate)} /{" "}
                                            {lang.get("Jahr")}
                                        </div>
                                    </>
                                )}
                            </div>
                            {domain.hosting ? (
                                <button
                                    className={"cart-button remove-hosting hosting-button"}
                                    onClick={() => {
                                        plausibleEvent("remove-hosting");
                                        removeHosting(domain);
                                    }}
                                >
                                    <Delete />
                                </button>
                            ) : (
                                <button
                                    className={"cart-button add-hosting red hosting-button"}
                                    onClick={() => {
                                        plausibleEvent("add-hosting");
                                        addHosting(domain, hostingData[0].id.toString());
                                    }}
                                >
                                    <AddCircle />
                                </button>
                            )}
                        </div>
                    ) : null}
                </div>
                <button
                    className={"cart-button delete"}
                    onClick={() => {
                        removeDomain(domain);
                        handleCartContent();
                    }}
                >
                    <Delete />
                </button>
            </div>
        </li>
    );
};
